import { ApiImageClient } from "@/api";

async function apiUserGetEmployee({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(`/employees/${id}?populate=*`).then(
      ({ data }) => data
    );
    return result;
  } catch (e) {
    console.error("apiUserEmployee_Error", e);
  }
}

async function apiUserGetEmployees() {
  try {
    // const companyId = localStorage.getItem("companyId");
    // if (!companyId) {
    //   throw new Error("Company ID not found in localStorage");
    // }
    // const result = await ApiImageClient.get(
    //   `/employees?populate=user&filters[company][documentId][$eq]=${companyId}`,
    // ).then(({ data }) => data);
    // return result;
  } catch (e) {
    console.error("apiUserGetEmployees_Error", e);
    throw e; // Re-throw the error to handle it in the calling function
  }
}

async function apiUserGetAllEmployeesForUser() {
  try {
    // Get current user info first to get their ID
    const userInfo = await ApiImageClient.get("/users/me").then(
      ({ data }) => data
    );

    // Then filter employees by the current user's ID
    const result = await ApiImageClient.get(
      `/employees?populate[0]=user&populate[1]=company&filters[user][documentId][$eq]=${userInfo.documentId}`
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetAllEmployeesForUser_Error", e);
    throw e;
  }
}

async function apiUserPutEmployees({ id, data }) {
  try {
    const result = await ApiImageClient.put(`/employees/${id}`, { data }).then(
      ({ data }) => data
    );
    return result;
  } catch (e) {
    console.error("apiUserPutEmployees_Error", e);
    return e;
  }
}

async function apiUserPostEmployee({ data }) {
  try {
    const result = await ApiImageClient.post(`/employees?populate=*`, {
      data,
    }).then(({ data }) => data);
    return result;
  } catch (error) {
    console.error("apiUserPostDepartment_Error", error);
    return error;
  }
}

export {
  apiUserGetEmployee,
  apiUserGetEmployees,
  apiUserGetAllEmployeesForUser,
  apiUserPutEmployees,
  apiUserPostEmployee,
};
